import { AllCardsType } from '../../../data/all-cards'
import { clasificacion } from '../../../data/clasification'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    //console.log('Recibido en interpret:', data)
    let consult
    if (data.tipo === '2') {
        consult = `Interpreta la tirada de cartas que realizaste para ${
            data.consultante.name
        } que necesita saber lo siguiente: ${data.consulta}, con las siguientes cartas: ${formatCardLabel(cards[0])}, ${formatCardLabel(cards[1])}, ${formatCardLabel(cards[2])}, ${formatCardLabel(cards[3])} y ${formatCardLabel(cards[4])}. Decide tú como tarotista experta que eres, cual es el mejor tipo de lectura que puedes hacer con estas cinco cartas en base a lo que el consultante necesita saber, pero no enumeres carta por carta, sino más bien, haz un relato mencionandolas dentro del relato. Si puedes ten en cuenta el signo zodiacal del consultante: ${
            data.consultante.zodiac
        }. Dirígete directamente al consultante.`
    } else {
        consult = `Respuesta a la consulta de ${data.consultante.name} de ${data.consultante.zodiac} sobre: ${
            data.consulta
        }:\n\n${cards[0].name}: ${clasificacion[cards[0].id] === 1 ? 'Positiva' : 'Negativa'}\n${cards[1].name}: ${
            clasificacion[cards[1].id] === 1 ? 'Positiva' : 'Negativa'
        }\n${cards[2].name}: ${clasificacion[cards[2].id] === 1 ? 'Positiva' : 'Negativa'}\n${cards[3].name}: ${
            clasificacion[cards[3].id] === 1 ? 'Positiva' : 'Negativa'
        }\n${cards[4].name}: ${clasificacion[cards[4].id] === 1 ? 'Positiva' : 'Negativa'}\n\nResultado: ${
            clasificacion[cards[0].id] +
                clasificacion[cards[1].id] +
                clasificacion[cards[2].id] +
                clasificacion[cards[3].id] +
                clasificacion[cards[4].id] >
            0
                ? 'Positivo'
                : 'Negativo'
        }\n\nLa clasificación de las cartas arroja un resultado ${
            clasificacion[cards[0].id] +
                clasificacion[cards[1].id] +
                clasificacion[cards[2].id] +
                clasificacion[cards[3].id] +
                clasificacion[cards[4].id] >
            0
                ? 'Positivo para la consulta realizada, por lo tanto la respuesta es un SI.'
                : 'Negativo para la consulta realizada, por lo tanto la respuesta es un NO.'
        }\n\nEspero que esta tirada de tarot ayude a aclarar tus dudas y recuerda que el tarot es una herramienta que brinda una guia y orientación en cuestiones de la vida, pero las decisiones que tomes y los sucesos en tu vida dependen de tus acciones.\n\nTe deseo la mejor de las suertes...`
    }

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
